import React from "react";

export interface StatCardProps {
  value: string;
  label: string;
}

export function StatCard({ value, label }: StatCardProps): React.ReactElement {
  return (
    <div className="bg-white border-l-4 border-navy rounded-lg h-[178px] flex flex-col justify-center px-6 min-w-[227px] shadow-sm transition-all duration-200 ease-out hover:shadow-lg hover:-translate-y-1">
      <span className="font-ribeye text-navy text-5xl font-normal leading-none">
        {value}
      </span>
      <span className="text-[#474242] text-xl mt-6 font-normal whitespace-pre-line">{label}</span>
    </div>
  );
}

export default StatCard;
